import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { serviceConfigSchema } from '../configurations/SharedServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderOriginatorDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.ORIGINATOR]: serviceConfigSchema,
    }),
});

export { servicesProviderOriginatorDataSchema };
//# sourceMappingURL=ServicesProviderOriginatorData.js.map
